export const INVOICE_PREVIEW_CARD_TITLE_TESTID =
  'automations.invoicePreviewCard.title'

export const INVOICE_PREVIEW_CARD_SKELETON_TESTID =
  'automations.invoicePreviewCard.skeleton'

export const INVOICE_PREVIEW_CARD_DUE_DATE_TESTID =
  'automations.invoicePreviewCard.dueDate'
